import React from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import "./case-items.css"
import { useTranslation } from 'react-i18next';




function CaseItems(props: any) {
    const getProductInfo = props.data;
    const getPolyProductInfo = props.polyData;
    const { t } = useTranslation();
    if (!getProductInfo) {
        return <div> No product information Available</div>
    }
    const isNonSerializedProd = getProductInfo?.hdnIsNonSerializedProd === "True";
    const ISResponse = getProductInfo?.ISResponse ? JSON.parse(getProductInfo.ISResponse) : null;
    const asset = ISResponse?.[0].Assets?.[0] || {};
    const entitlements = asset?.ContractEntitlement || [];
    const bestEntitlement = entitlements.find((item: any) => item?.IsBestEntitlement) || entitlements[0] || null;
    const Status = bestEntitlement?.Status || null;
    const EndDate = bestEntitlement?.EndDate || null;
    const EntitlementType = bestEntitlement?.EntitlementType || null;
    const  noImage = require ("@assets/icons/image.png");
    const formatDate = (dateString: string): string => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    };
    let endDateFormatted = formatDate(EndDate)
    let caseStatus: React.ReactNode = null;
    if (EntitlementType !== null) {
        if ((EntitlementType.toLowerCase().includes("carepack"))) {

            switch (Status?.toLowerCase()?.trim()) {
                case "active":
                    caseStatus = (<span className="text-success spnActive"> <strong>{t('HPI.General.js.Active',{defaultValue:'Active'})} :</strong> {t('HPI.Product.ExtendedWarranty',{defaultValue:'Covered under Extended warranty , Expiration date:'})}  <strong> {endDateFormatted} </strong> </span>);
                    break;
                case "future":
                    caseStatus = (<span className="text-success spnActive"> <strong>Non-Active :</strong>{t('HPI.Product.ExtendedWarranty',{defaultValue:'Covered under Extended warranty , Expiration date:'})}<strong>{endDateFormatted} </strong> </span>);
                    break;
                case "evergreen":
                    caseStatus = (<span className="text-success spnActive"> <strong>{t('HPI.General.js.Active',{defaultValue:'Active'})} :</strong>{t('HPI.Product.ExtendedWarranty',{defaultValue:'Covered under Extended warranty , Expiration date:'})} <strong>{endDateFormatted} </strong> </span>);
                    break;
                case "expired":
                    caseStatus = (<span className="text-danger spnExpired"> <strong className='failCase'>{t('HPI.General.js.Expired',{defaultValue:'Expired'})} :</strong><span className='failCase'> {t('HPI.Product.ExtendedWarranty.ExtendedExpired',{defaultValue:'Extended warranty has expired, Expiration date:'})}  </span><strong className='failCase'>{endDateFormatted} </strong> </span>);
                    break;
                case "pending":
                    caseStatus = (<span className="text-danger spnExpired"> <strong>{Status}</strong> {t('HPI.General.js.Pending',{defaultValue:'HP regrets it cannot process your request at this time. Thank you for your interest in HP products and services'})}  </span>);
                    break;
                default:
                    caseStatus = (<span className="text-success spnActive"> <strong>{Status}</strong>{t('HPI.General.js.Unspecified',{defaultValue:'Unspecified, Expiration date : '})}  <strong>{endDateFormatted} </strong> </span>);
                    break;
            }
        } else if (EntitlementType.toLowerCase().includes("warranty")) {

            switch (Status?.toLowerCase()?.trim()) {
                case "active":
                    caseStatus = (<span className="text-success spnActive"> <strong>{t('HPI.General.js.Active',{defaultValue:'Active'})} :</strong>{t('HPI.General.js.CoveredWarranty',{defaultValue:'Covered under Manufacturer warranty , Expiration date:'})}  <strong> {endDateFormatted} </strong> </span>);
                    break;
                case "future":
                    caseStatus = (<span className="text-success spnActive"> <strong>Non-Active :</strong>{t('HPI.General.js.CoveredWarranty',{defaultValue:'Covered under Manufacturer warranty , Expiration date:'})}<strong>{endDateFormatted} </strong> </span>);
                    break;
                case "evergreen":
                    caseStatus = (<span className="text-success spnActive"> <strong>{t('HPI.General.js.Active',{defaultValue:'Active'})} :</strong>{t('HPI.General.js.CoveredWarranty',{defaultValue:'Covered under Manufacturer warranty , Expiration date:'})}  <strong>{endDateFormatted} </strong> </span>);
                    break;
                case "expired":
                    caseStatus = (<span className="text-danger spnExpired"> <strong>{t('HPI.General.js.Expired',{defaultValue:'Expired'})} :</strong> {t('HPI.General.js.ExpiredWarranty',{defaultValue:'Manufacturer warranty has expired, Expiration Date:'})} <strong>{endDateFormatted} </strong> </span>);
                    break;
                case "pending":
                    caseStatus = (<span className="text-success spnActive"> <strong>{Status}</strong> {t('HPI.General.js.Pending',{defaultValue:'HP regrets it cannot process your request at this time. Thank you for your interest in HP products and services'})}  </span>);
                    break;
                default:
                    caseStatus = (<span className="text-success spnActive"> <strong>{Status}</strong>{t('HPI.General.js.Unspecified',{defaultValue:'Unspecified, Expiration date : '})}  <strong>{endDateFormatted} </strong> </span>);
                    break;

            }
        } else if (EntitlementType.toLowerCase().includes("contract")) {
            switch (Status?.toLowerCase()?.trim()) {
                case "active":
                    caseStatus = (<span className="text-success spnActive"> <strong>{t('HPI.General.js.Active',{defaultValue:'Active'})} :</strong> {t('HPI.General.js.CoveredContract',{defaultValue:'Covered under contract, Expiration date :'})} <strong>{endDateFormatted} </strong> </span>);
                    break;
                case "future":
                    caseStatus = (<span className="text-success spnActive"> <strong>Non-Active :</strong>{t('HPI.General.js.CoveredContract',{defaultValue:'Covered under contract, Expiration date :'})}  <strong>{endDateFormatted} </strong> </span>);
                    break;
                case "evergreen":
                    caseStatus = (<span className="text-success spnActive"> <strong>{t('HPI.General.js.Active',{defaultValue:'Active'})} :</strong>{t('HPI.General.js.CoveredContract',{defaultValue:'Covered under contract, Expiration date :'})}  <strong>{endDateFormatted} </strong> </span>);
                    break;
                case "expired":
                    caseStatus = (<span className="text-success spnExpired"> <strong>{t('HPI.General.js.Expired',{defaultValue:'Expired'})} :</strong> {t('HPI.General.js.ExpiredContract',{defaultValue:'Contract has expired, Expiration date :'})} <strong>{endDateFormatted} </strong> </span>);
                    break;
                case "pending":
                    caseStatus = (<span className="text-danger spnExpired"> <strong>{t('HPI.General.js.Pending',{defaultValue:'HP regrets it cannot process your request at this time. Thank you for your interest in HP products and services '})}</strong> </span>);
                    break;
                default:
                    caseStatus = (<span className="text-success spnActive"> <strong>{Status}</strong>{t('HPI.General.js.Unspecified',{defaultValue:'Unspecified, Expiration date : '})} <strong>{endDateFormatted} </strong> </span>);
                    break;

            }
        } else if (EntitlementType.toLowerCase().includes("subscription")){
            switch (Status?.toLowerCase()?.trim()) {
                case "active":
                    caseStatus = (<span className="text-success spnActive"> <strong>{t('HPI.General.js.Active',{defaultValue:'Active'})} :</strong> {t('HPI.Product.ExtendedWarranty',{defaultValue:'Covered under Extended warranty , Expiration date:'})} <strong>{endDateFormatted} </strong> </span>); 
                    break;
                case "future":
                    caseStatus = (<span className="text-success spnActive"> <strong>Non-Active :</strong>{t('HPI.Product.ExtendedWarranty',{defaultValue:'Covered under Extended warranty , Expiration date:'})} <strong>{endDateFormatted} </strong> </span>);
                    break;
                case "evergreen":
                    caseStatus = (<span className="text-success spnActive"> <strong>{t('HPI.General.js.Active',{defaultValue:'Active'})} :</strong>{t('HPI.Product.ExtendedWarranty',{defaultValue:'Covered under Extended warranty , Expiration date:'})}<strong>{endDateFormatted} </strong> </span>);
                    break;
                case "expired":
                    caseStatus = (<span className="text-success spnExpired"> <strong>{t('HPI.General.js.Expired',{defaultValue:'Expired'})} :</strong> {t('HPI.Product.ExtendedWarranty.ExtendedExpired',{defaultValue:'Extended warranty has expired,, Expiration date :'})} <strong>{endDateFormatted} </strong> </span>);
                    break;
                case "pending":
                    caseStatus = (<span className="text-danger spnExpired"> <strong>{t('HPI.General.js.Pending',{defaultValue:'HP regrets it cannot process your request at this time. Thank you for your interest in HP products and services '})}</strong>  </span>);
                    break;
                default:
                    caseStatus = (<span className="text-success spnActive"> <strong>{Status}</strong>{t('HPI.General.js.Unspecified',{defaultValue:'Unspecified, Expiration date : '})} <strong>{endDateFormatted} </strong> </span>);
                    break;

            }
        }
    }

    return (
        <>
            <div className='product-info'>
                <Row>
                    <Col sm={3} className='product-container'>
                        <div className="profile-pic">
                        {/* <img src={getProductInfo?.ImageURL || noImage} 
                            alt={getProductInfo?.ImageURL} className='img-fluid' /> 
                             */}
                            {getProductInfo?.ImageURL ? <img src={getProductInfo?.ImageURL} 
                            alt={getProductInfo?.ImageURL} className='img-fluid' /> 
                            : <div className='image-placeholder'> <img src={noImage} alt="no-image"/></div>}
                        </div>
                    </Col>

                    <Col sm={9}>
                        <Col className='info-col'>
                            <label className='full-width'>{isNonSerializedProd ? getProductInfo.productName || "Not Applicable" : asset?.AssetName || "Not Applicable"}</label>
                        </Col>
                        <Col className='info-col'>
                            <label>{t('HPI.ProductInfo.WarrantyStatus', { defaultValue: 'Warranty status :' })}</label>
                            <p style={{ display: 'contents', fontSize: 'medium' }}> {isNonSerializedProd ? " Not Applicable" : caseStatus}
                            </p>
                        </Col>
                        <Col>
                            <Container fluid>
                                <Row>
                                    <Col className='info-col'>
                                        <label>{t('HPI.ProductInfo.SerialNumber', { defaultValue: 'Serial number :' })}</label>
                                        <p> {isNonSerializedProd ? "Not Applicable"  : asset?.AssertSerialNumber || ( getPolyProductInfo?.ainfo || "Not Applicable")}</p>
                                    </Col>
                                    <Col className='info-col'>
                                        <label>{t('HPI.ProductInfo.ProductNumber', { defaultValue: 'Product number :' })}</label>
                                        <p> {isNonSerializedProd ? getProductInfo.productNumber || " Not Applicable" : asset?.Product?.ProductId ||( getPolyProductInfo?.pno || "Not Applicable")}</p>
                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                    </Col>
                </Row>
            </div>

        </>
    )
    }

export default CaseItems